export class AbstractResource {
    private _uri: string | null;
    constructor() {
        this._uri = null;
    }

    get uri() {
        return this._uri;
    }

    set uri(value) {
        this._uri = value;
    }
}
